import type { FaireProductEntity } from "../../entity_types/product";

export const p_es2h8fhr4e: FaireProductEntity = {
  token: "p_es2h8fhr4e",
  type: "product",
  name: "Dearly Beloved (Prince) Square Notepad",
  brandName: "Sugarboo & Co",
  imageUrl:
    "https://cdn.faire.com/fastly/0da672b76d2ed518831d9f5531217d569a854102310a119957af395527bf7c75.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5ae22639aaeff650bcc0193cfbae5f26c69f3c1087674c899d0fdcbf658612a3.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
